import IconView from "../IconView";

let OfficeViewerIconView = IconView.createPlugin("office-viewer", {

    async onOpen() {
        const fileURL = this.model.get("url");
        const officeURL = await system.getOfficeURL(fileURL);

        system.runApp({
            type: "Iframe",

            title: this.model.get("title"),
            src: officeURL
        });
    }
});

export default OfficeViewerIconView;
